import { render } from "./addappversion.vue?vue&type=template&id=41076ffa&scoped=true"
import script from "./addappversion.vue?vue&type=script&lang=js"
export * from "./addappversion.vue?vue&type=script&lang=js"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41076ffa"]])

export default __exports__